export default {
    cn: {
        versionReport: {
            title: '已计算版本报表',
            search: '搜索',
            clauses_text: "显示条目数",
            amount: "总数",
            present: "当前",
            nodata: "没有查询到数据",
            btn: '版本回退',
            commit: '您真的要确认吗？',
            status_mapper: { "-1": "所有", "0": "生效中", "1": "已解绑" },
            selectArr: [
                { label: '账号', value: 'LOGIN' },
                { label: '代理账号', value: 'IB_ID' },
            ],
            first_row: [
                { key: 'LOGIN', name: '账号' },
                { key: 'IB_ID', name: '代理账号' },
                { key: 'VERSION', name: '版本' },
                { key: 'LAST_CALC_START_DATE', name: '计算开始日期' },
                { key: 'LAST_CALC_END_DATE', name: '计算结束日期' },
                { key: 'PERCENTAGE', name: '百分比' },
                { key: 'TOTAL_PL', name: '总盈亏' },
                { key: 'SHARE_PL', name: '分成利润' },
                { key: 'is_deleted', name: '账号当前状态' },
            ]
        }
    },
    hk: {
        versionReport: {
            title: '已計算版本報表',
            search: '搜索',
            clauses_text: "顯示條目數",
            amount: "總數",
            present: "當前",
            nodata: "沒有查詢到數據",
            btn: '版本回退',
            commit: '您真的要確認嗎？',
            status_mapper: { "-1": "所有", "0": "生效中", "1": "已解綁" },
            selectArr: [
                { label: '賬號', value: 'LOGIN' },
                { label: '代理賬號', value: 'IB_ID' },
            ],
            first_row: [
                { key: 'LOGIN', name: '賬號' },
                { key: 'IB_ID', name: '代理賬號' },
                { key: 'VERSION', name: '版本' },
                { key: 'LAST_CALC_START_DATE', name: '計算開始日期' },
                { key: 'LAST_CALC_END_DATE', name: '計算結束日期' },
                { key: 'PERCENTAGE', name: '百分比' },
                { key: 'TOTAL_PL', name: '總盈虧' },
                { key: 'SHARE_PL', name: '分成利潤' },
                { key: 'is_deleted', name: '賬號當前狀態' },
            ]
        }
    },
    en: {
        versionReport: {
            title: 'Version Report',
            search: 'Search',
            clauses_text: "Display",
            amount: " Total Count",
            present: "Current",
            nodata: "No data found",
            btn: 'Version Back',
            commit: 'Do you really want to confirm?',
            status_mapper: { "-1": "All", "0": "Active", "1": "Deleted" },
            selectArr: [
                { label: 'Login', value: 'LOGIN' },
                { label: 'IB Account', value: 'IB_ID' },
            ],
            first_row: [
                { key: 'LOGIN', name: 'Login' },
                { key: 'IB_ID', name: 'IB Account' },
                { key: 'VERSION', name: 'Version' },
                { key: 'LAST_CALC_START_DATE', name: 'Calculate Start Date' },
                { key: 'LAST_CALC_END_DATE', name: 'Calculate End Date' },
                { key: 'PERCENTAGE', name: 'Percentage' },
                { key: 'TOTAL_PL', name: 'Total PL' },
                { key: 'SHARE_PL', name: 'Share PL' },
                { key: 'is_deleted', name: 'Current Status' },
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/MultiLanguage/ProfitShareSetting/versionReport.js